import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';

import arrowIcon from '../assets/icon/baise_jiantou_geren_icon.png';

const Header = styled.div`
  background: #23a7f1;
  background: linear-gradient(90deg, #23a7f1 0%,#22a8f1 100%);
  height: 69px;
  border-top: 1px solid #fcf6f0;
  border-bottom: 1px solid #8bccee;
  padding: 18px 20px;
`;

const Title = styled.h1`
  display: inline;
  color: white;
  font-size: 32px;
  line-height: 1;
  font-weight: normal;
`;

const SubTitle = styled.h2`
  display: inline;
  color: white;
  font-size: 16px;
  line-height: 1;
  font-weight: normal;
  text-transform: uppercase
`;

const ArrowIcon = styled.img`
  position: relative
  top: -5px
  height: 16px
  margin-right: 12px
  margin-top: -6px
`;

class SectionHeader extends Component {
  render() {
    const { title, subtitle } = this.props;
    return (
      <Header>
        <ArrowIcon src={arrowIcon} alt='arrow' />
        <Title>{title}</Title>
        {subtitle ? <Title> / </Title> : null}
        {subtitle ? <SubTitle>{subtitle}</SubTitle> : null}
      </Header>
    );
  }
}

SectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};
SectionHeader.defaultProps = {
  subtitle: null,
};

export default SectionHeader;



// WEBPACK FOOTER //
// ./src/components/section-header.jsx